module.exports = __webpack_public_path__ + "img/bg1.ee3721e7.png";